import React from 'react';
import { PurchaseorderDataForm } from '../../../../app/models/PurchaseOrder';
import { ExchangeRateDateEnum } from '../../../../app/shared/enums';

interface Props {
  purchaseOrderDataForm: PurchaseorderDataForm;
}

const PurchaseOrderInvoicingShowForm: React.FC<Props> = ({ purchaseOrderDataForm }) => {
  if (!purchaseOrderDataForm) return null;

  const {
    payment_method,
    currency,
    payment_condition,
    days_count,
    exchange_rate_date_value,
    fixed_date,
    final_days,
    final_months,
    final_year
  } = purchaseOrderDataForm;

  const exchangeDateId = exchange_rate_date_value?.id;

  // Solo FECHA_FIJA es fixed; todo lo demás usa fields numéricos
  const isFixed = exchangeDateId === ExchangeRateDateEnum.FECHA_FIJA;

  return (
    <>
      {/* Datos generales */}
      <div className="mb-2 row">
        <div className="col-md-6">
          <label className="col-form-label">Forma de pago</label>
          <input
            type="text"
            className="form-control bg-light"
            value={payment_method}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label className="col-form-label">Moneda</label>
          <input
            type="text"
            className="form-control bg-light"
            value={currency}
            readOnly
          />
        </div>
      </div>
      <div className="mb-2 row">
        <div className="col-md-6">
          <label className="col-form-label">Condición de pago</label>
          <input
            type="text"
            className="form-control bg-light"
            value={payment_condition}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label className="col-form-label">Cantidad de días</label>
          <input
            type="text"
            className="form-control bg-light"
            value={days_count}
            readOnly
          />
        </div>
      </div>

      {/* Fecha tipo de cambio */}
      <div className="mb-2 row">
        <div className="col-md-6">
          <label className="col-form-label">Fecha tipo de cambio</label>
          <input
            type="text"
            className="form-control bg-light"
            value={exchange_rate_date_value?.name || ''}
            readOnly
          />
        </div>
      </div>

      {isFixed ? (
        // Modo fecha fija
        <div className="mb-2 row">
          <div className="col-md-6">
            <label className="col-form-label">Fecha fija</label>
            <input
              type="date"
              className="form-control bg-light"
              value={fixed_date || ''}
              readOnly
            />
          </div>
        </div>
      ) : (
        // Modo numérico (incluye FECHA_FACTURA y ULTIMO_DIA_MES_ENTREGA)
        <div className="mb-2 row">
          <div className="col-md-3">
            <label className="col-form-label">Días (Final)</label>
            <input
              type="number"
              className="form-control bg-light"
              value={final_days ?? ''}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label className="col-form-label">Meses (Final)</label>
            <input
              type="number"
              className="form-control bg-light"
              value={final_months ?? ''}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label className="col-form-label">Año (Final)</label>
            <input
              type="number"
              className="form-control bg-light"
              value={final_year ?? ''}
              readOnly
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PurchaseOrderInvoicingShowForm;
